"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ar_viewer_1 = __importDefault(require("./ar-viewer"));
class RealityViewer extends ar_viewer_1.default {
    constructor() {
        super();
    }
    get nodeType() {
        return "Reality Viewer";
    }
    get device() {
        return "ios";
    }
    start() {
        if (!this.modelUrl) {
            throw new Error("RealityViewer.start() - model url not set, use RealityViewer.modelUrl");
        }
        const anchor = document.createElement("a");
        anchor.setAttribute("rel", "ar");
        anchor.appendChild(document.createElement("img"));
        anchor.setAttribute("href", this.modelUrl);
        anchor.click();
    }
}
exports.default = RealityViewer;
